export default {
  en: {
    addAgent: 'Add Agent',
    agentName: 'Agent Name',
    type: 'Type',
    market: 'Market',
    save: 'Save',
    cancel: 'Cancel',
    add: 'Add',
    added: 'Added',
    keyword: 'Keyword'
  },
  th: {
    addAgent: 'เพิ่มตัวแทน',
    agentName: 'ชื่อตัวแทน',
    type: 'ประเภท',
    market: 'ตลาด',
    save: 'บันทึก',
    cancel: 'ยกเลิก',
    add: 'เพิ่ม',
    added: 'เพิ่มแล้ว',
    keyword: 'ค้นหา'
  }
}
